import {
  Box,
  BrandingContainer as BrandingContainerBase,
  Footer as FooterDS,
  FooterItem,
  GlobalFooter as GlobalFooterBase,
  Link,
  Logos,
  Typography,
} from '@cambridgeassessment/cambridge-ui';
import React, { memo } from 'react';
import envVars from '../../env';
import { useStyles } from './styles';

// Cambridge-UI was built for React 16/17 — these components lack explicit children prop declarations
const BrandingContainer = BrandingContainerBase as React.FC<
  React.PropsWithChildren<Record<string, unknown>>
>;
const GlobalFooter = GlobalFooterBase as React.FC<
  React.PropsWithChildren<{ copyright: string }>
>;

const Footer: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.footer}>
      <Box className={classes.logoRow}>
        <Logos.CambridgeUniversityPressAndAssessment />
      </Box>
      <FooterDS logoBreakpoint="sm" maxWidth={false}>
        <FooterItem title="What we do" minWidth="423.68px">
          <div className={classes.twoColumnLayout}>
            <div>
              <Typography
                className={classes.paragraph}
                gutterBottom
                variant="body2"
              >
                <Link
                  variant="secondary"
                  underline="hover"
                  href="https://www.cambridge.org/gb/universitypress"
                >
                  Academic Research, Teaching and Learning
                </Link>
              </Typography>
              <Typography
                className={classes.paragraph}
                gutterBottom
                variant="body2"
              >
                <Link
                  variant="secondary"
                  underline="hover"
                  href="https://www.cambridgeenglish.org/"
                >
                  English
                </Link>
              </Typography>
              <Typography
                className={classes.paragraph}
                gutterBottom
                variant="body2"
              >
                <Link
                  variant="secondary"
                  underline="hover"
                  href="https://www.cambridgeinternational.org/"
                >
                  International Education
                </Link>
              </Typography>
              <Typography
                className={classes.paragraph}
                gutterBottom
                variant="body2"
              >
                <Link
                  variant="secondary"
                  underline="hover"
                  href="https://www.cambridge.org/gb/education"
                >
                  Educational resources for schools
                </Link>
              </Typography>
              <Typography
                className={classes.paragraph}
                gutterBottom
                variant="body2"
              >
                <Link
                  variant="secondary"
                  underline="hover"
                  href="https://www.cambridge.org/gb/universitypress/bibles"
                >
                  Bibles
                </Link>
              </Typography>
            </div>
            <div>
              <Typography
                className={classes.paragraph}
                gutterBottom
                variant="body2"
              >
                <Link
                  variant="secondary"
                  underline="hover"
                  href="https://www.cambridge.org/gb/partnership"
                >
                  Partnership for Education
                </Link>
              </Typography>
              <Typography
                className={classes.paragraph}
                gutterBottom
                variant="body2"
              >
                <Link
                  variant="secondary"
                  underline="hover"
                  href="https://www.cambridge.org/authorhub/"
                >
                  Author support
                </Link>
              </Typography>
              <Typography
                className={classes.paragraph}
                gutterBottom
                variant="body2"
              >
                <Link
                  variant="secondary"
                  underline="hover"
                  href="https://www.cambridgebookshop.co.uk/"
                >
                  Bookshop
                </Link>
              </Typography>
              <Typography
                className={classes.paragraph}
                gutterBottom
                variant="body2"
              >
                <Link
                  variant="secondary"
                  underline="hover"
                  href="https://www.cambridge.org/educational-research"
                >
                  Educational Research
                </Link>
              </Typography>
              <Typography
                className={classes.paragraph}
                gutterBottom
                variant="body2"
              >
                <Link
                  variant="secondary"
                  underline="hover"
                  href="https://www.cambridge.org/the-assessment-network"
                >
                  The Assessment Network
                </Link>
              </Typography>
              <Typography
                className={classes.paragraph}
                gutterBottom
                variant="body2"
              >
                <Link
                  variant="secondary"
                  underline="hover"
                  href="https://www.ocr.org.uk/"
                >
                  Cambridge OCR
                </Link>
              </Typography>
            </div>
          </div>
        </FooterItem>
        <FooterItem title="About us" minWidth="224.8px">
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/about-us"
            >
              About us
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/our-story"
            >
              Our story
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/archives-and-heritage"
            >
              Archives and Heritage
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/people-and-planet"
            >
              People and planet
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/governance"
            >
              Governance
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/news-and-insights"
            >
              News and insights
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/legal"
            >
              Legal
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/about-us/accessibility"
            >
              Accessibility
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/rights-and-permissions"
            >
              Rights and permissions
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://help.cambridge.org/"
            >
              Contact us
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/contact-us/media-enquiries"
            >
              Media enquiries
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/shopping-help#cancelling-your-order"
            >
              Cancel an order
            </Link>
          </Typography>
        </FooterItem>
        <BrandingContainer>
          {envVars.IS_CHINA && (
            <div className={classes.license} data-testid="icpLicenseString">
              {envVars.ICP_LICENSE_STRING}
            </div>
          )}
        </BrandingContainer>
      </FooterDS>
      <Box className={classes.globalFooterWrapper}>
        <GlobalFooter
          copyright={`© ${new Date().getFullYear()} Cambridge University Press & Assessment`}
        >
          <Typography className={classes.bottomFooterLinks} gutterBottom>
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/rights-and-permissions"
            >
              Rights and permissions
            </Link>
          </Typography>
          <Typography className={classes.bottomFooterLinks} gutterBottom>
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/legal"
            >
              Legal
            </Link>
          </Typography>
          <Typography className={classes.bottomFooterLinks} gutterBottom>
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/legal/privacy"
            >
              Privacy
            </Link>
          </Typography>
          <Typography className={classes.bottomFooterLinks} gutterBottom>
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/people-and-planet/anti-slavery-and-human-trafficking"
            >
              Modern slavery
            </Link>
          </Typography>
          <Typography className={classes.bottomFooterLinks} gutterBottom>
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/people-and-planet"
            >
              People and planet
            </Link>
          </Typography>
          <Typography className={classes.bottomFooterLinks} gutterBottom>
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/people-and-planet/diversity-and-inclusion"
            >
              Diversity and inclusion
            </Link>
          </Typography>
          <Typography className={classes.bottomFooterLinks} gutterBottom>
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/sitemap"
            >
              Sitemap
            </Link>
          </Typography>
        </GlobalFooter>
      </Box>
    </Box>
  );
};

export default memo(Footer);
